import { REPORT_SETTINGS_TEMPLATE_NAME_MAX_LENGTH } from "@common/constants/reports/report-settings-template";
import { isKickReportTemplate } from "./isKickReportTemplate";

export interface ReportTemplateDetailsValues {
    name: string;
    description: string;
}

interface ReportTemplateDetailsSource {
    name: string;
    description: string | null;
}

export const emptyReportTemplateDetails: ReportTemplateDetailsValues = {
    name: "",
    description: "",
};

export const getEditReportTemplateDetails = (
    template: ReportTemplateDetailsSource,
): ReportTemplateDetailsValues => ({
    name: template.name,
    description: template.description ?? "",
});

export const getDuplicateReportTemplateDetails = (
    template: ReportTemplateDetailsSource & { templateId: string | null },
): ReportTemplateDetailsValues => ({
    description: isKickReportTemplate(template)
        ? ""
        : (template.description ?? ""),
    name: `Copy of ${template.name}`.slice(
        0,
        REPORT_SETTINGS_TEMPLATE_NAME_MAX_LENGTH,
    ),
});

export const buildUpdateReportTemplateRequest = (
    values: ReportTemplateDetailsValues,
) => ({
    name: values.name.trim(),
    description: values.description.trim() || null,
});

export const buildCreateReportTemplateRequest = ({
    values,
    sourceTemplateId = null,
}: {
    values: ReportTemplateDetailsValues;
    sourceTemplateId?: string | null;
}) => ({
    ...buildUpdateReportTemplateRequest(values),
    sourceTemplateId,
});
